import { ContentChild, Directive, input } from '@angular/core'
import { GenericTableColumnAlign, GenericTableSkeletonLayout } from '../types/generic-table.types'
import { GenericTableCellDefDirective } from './generic-table-cell-def.directive'

@Directive({
  selector: '[appGenericTableColumn]'
})
export class GenericTableColumnDirective {
  public readonly field = input.required<string>()
  public readonly header = input.required<string>()
  public readonly sortable = input(false)
  // Width for small/mobile screens (below md)
  public readonly smWidth = input<string | undefined>(undefined)
  // Width for large screens
  public readonly width = input<string | undefined>(undefined)
  // Width for XL screens
  public readonly widthXl = input<string | undefined>(undefined)
  public readonly minWidth = input<string | undefined>(undefined)
  public readonly maxWidth = input<string | undefined>(undefined)
  public readonly columnSize = input<string | undefined>(undefined)
  public readonly cellPadding = input<'default' | 'none'>('default')
  public readonly align = input<GenericTableColumnAlign>('left')
  public readonly skeletonBlockCount = input<number | null>(null)
  public readonly skeletonLayout = input<GenericTableSkeletonLayout>('stack')

  @ContentChild(GenericTableCellDefDirective)
  public cellDef?: GenericTableCellDefDirective
}
